import { TimeFormat } from '../../../constants/timezone';
import { useTimeRangeOptions } from '../../../fixtures/mentorAvailability/hooks/use-time-range-options';
import { SingleChoiceDropdown } from '../SingleChoiceDropdown/SingleChoiceDropdown';

import './TimeSelector.scss';

import { DataTestIds } from '@repo/frontend-shared';

interface TimeSelectorProps {
  value: string;
  onTimeChange: (value: string) => void;
  minAfter?: string;
  disabled?: boolean;
  dataTestId?: string;
}

const START_HOUR = 0;
const END_HOUR = 24;

export function TimeSelector({ value, onTimeChange, minAfter, disabled = false, dataTestId }: TimeSelectorProps) {
  // 15-minute steps and 12hr (am/pm) display; values remain in 24hr HH:mm for backend compatibility
  const timeRangeOptions = useTimeRangeOptions(START_HOUR, END_HOUR, 15, TimeFormat.ampm);
  const filteredOptions = minAfter ? timeRangeOptions.filter(option => option.value >= minAfter) : timeRangeOptions;

  const handleTimeChange = (option: { id: string; name: string } | null) => {
    if (option) {
      onTimeChange(option.id);
    }
  };

  const selectedOption = filteredOptions.find(option => option.value === value);

  return (
    <div className="TimeSelector">
      <SingleChoiceDropdown
        hideDropdownArrow={false}
        value={selectedOption ? { id: selectedOption.value, name: selectedOption.label } : null}
        onChange={handleTimeChange}
        getOptions={async () =>
          filteredOptions.map(option => ({
            id: option.value,
            name: option.label,
          }))
        }
        inputPlaceholder="Select time"
        isDisabled={disabled}
        dataTestId={dataTestId ?? DataTestIds.COMMON.TIME_SELECTOR}
      />
    </div>
  );
}
